// Sort waivers so that purely-numeric names appear first (sorted numerically)
// and remaining names follow in case-insensitive alphabetical order.
const isNumericName = (name) =>
  typeof name === 'string' && /^\s*\d+\s*$/.test(name);

export const sortWaivers = (waivers = []) => {
  return [...(waivers || [])].sort((a, b) => {
    const aName = a?.name || '';
    const bName = b?.name || '';
    const aNumeric = isNumericName(aName);
    const bNumeric = isNumericName(bName);

    if (aNumeric && bNumeric) {
      return parseInt(aName, 10) - parseInt(bName, 10);
    }
    if (aNumeric) return -1;
    if (bNumeric) return 1;
    return aName.localeCompare(bName, undefined, { sensitivity: 'base' });
  });
};

export default sortWaivers;
